import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'


const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/home/uso',
    name: 'EmUso',
    component: () => import('../views/EmUso.vue')
  },
  {
    path: '/scanner',
    name: 'Scanner',
    component: () => import('../views/Scanner.vue')
  },
  // {
  //   path: '/about',
  //   name: 'About',

  //   component: () => import('../views/About.vue')
  // },
  {
    path: '/lista-manutencao',
    name: 'ListManutencao',
    component: () => import('../views/ListManutencao.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/config',
    name: 'Configuracao',
    component: () => import('../views/Configuracao.vue')
  }, {
    path: '/all',
    name: 'Todos',
    component: () => import('../views/Todos.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  mode: 'history',

  routes
})

export default router
